import { lazy, Suspense, type ComponentType, type ReactNode } from "react";

/**
 * SCREENS LOAD WHEN THEY ARE OPENED (spec §88A performance). The Design
 * editor, Capital Plan, Find, reports and admin were all in the first
 * bundle, so a person signing in downloaded every screen before seeing one.
 * lazyScreen() turns a named export into a lazily loaded component; the
 * ScreenLoading fallback holds the page's shape so nothing jumps.
 */
export function lazyScreen<P extends object>(load: () => Promise<Record<string, unknown>>, name: string) {
  return lazy(async () => ({ default: (await load())[name] as ComponentType<P> }));
}

export function ScreenLoading({ label = "Loading" }: { label?: string }) {
  return (
    <div className="screen-loading" role="status" aria-live="polite">
      <span className="visually-hidden">{label}…</span>
      <span className="skeleton" style={{ height: 28, width: "32%" }} />
      <span className="skeleton" style={{ height: 14, width: "52%" }} />
      <div className="screen-loading-grid">
        <span className="skeleton" />
        <span className="skeleton" />
        <span className="skeleton" />
      </div>
      <span className="skeleton" style={{ height: 220 }} />
    </div>
  );
}

export function Lazy({ children, label }: { children: ReactNode; label?: string }) {
  return <Suspense fallback={<ScreenLoading label={label} />}>{children}</Suspense>;
}
